module.exports = __webpack_public_path__ + "static/media/icon-projects.ed999428.svg";